import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'
import createRootReducer from './reducers'
import { configureFlashMessages } from 'redux-flash-messages'
import { screenTracking } from './middlewares/analytics'

export const history = require("history").createBrowserHistory()

const enhancers = []
const middleware = [
  thunk,
  routerMiddleware(history),
  screenTracking
]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

const store = createStore(
  createRootReducer(history),
  composedEnhancers
)

configureFlashMessages({
  dispatch: store.dispatch
})

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(rootReducer)
    })
  }
}

const addPromiseSupportToDispatch = (store) => {
  const rawDispatch = store.dispatch

  return (action) => {
    if (typeof action.then === 'function') {
      return action.then(rawDispatch)
    }
    return rawDispatch(action)
  }
}

store.dispatch = addPromiseSupportToDispatch(store)


export default store
